import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=2cdcb5aa"
import script from "./EvaluationList.vue?vue&type=script&lang=js"
export * from "./EvaluationList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=2cdcb5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports